import { useTranslation } from 'react-i18next';
import styles from './GatheringIndicator.module.css';

/**
 * Reverent "Gathering your prayers…" indicator shown on PrayPage while the
 * initial cloud sync runs after a fresh sign-in on a device with zero
 * local prayers. Soft gold breathing dot + italic text — no spinner, no
 * progress bar (both would feel anxious, wrong for a prayer app). Fades
 * away when useSyncStore.isInitialSyncing flips back to false.
 *
 * Not blocking — the user can keep typing a new prayer while this shows.
 */
export default function GatheringIndicator() {
  const { t } = useTranslation();
  return (
    <div className={styles.indicator} role="status" aria-live="polite">
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.text}>{t('pray.gathering')}</span>
    </div>
  );
}
